import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

import { getOrEmptyObject, getOrFalse, getOrNull, getStringProp } from '@mews/fp';

import { ApplicationState } from '../../../types';
import { WithAvailabilityBlockId } from '../../../types/selectors/selectorPropTypes';
import { getEntities } from '../getEntities';
import { Entities } from '../types';
import { AvailabilityBlock, AvailabilityBlocks, AvailabilityBlocksData } from './types';

const getAvailabilityBlocks = createSelector<ApplicationState, Entities, AvailabilityBlocks>(
    getEntities,
    get('availabilityBlocks')
);

const getAvailabilityBlocksData = createSelector(getAvailabilityBlocks, getOrEmptyObject('data'));
const getAvailabilityBlocksMeta = createSelector(getAvailabilityBlocks, getOrEmptyObject('meta'));

export const hasAvailabilityBlocksFailed = createSelector(getAvailabilityBlocksMeta, getOrFalse('hasFailed'));
export const areAvailabilityBlocksFetching = createSelector(getAvailabilityBlocksMeta, getOrFalse('isFetching'));

const getAvailabilityBlock = createSelector<
    ApplicationState,
    WithAvailabilityBlockId,
    string,
    AvailabilityBlocksData,
    AvailabilityBlock | undefined
>(getStringProp('availabilityBlockId'), getAvailabilityBlocksData, get);

export const getAvailabilityBlockRateId = createSelector(getAvailabilityBlock, get('rateId'));
export const getAvailabilityBlockServiceId = createSelector(getAvailabilityBlock, get('serviceId'));
export const getAvailabilityBlockStartUtc = createSelector(getAvailabilityBlock, get('startUtc'));
export const getAvailabilityBlockEndUtc = createSelector(getAvailabilityBlock, get('endUtc'));
export const getAvailabilityBlockName = createSelector(getAvailabilityBlock, getOrNull('name'));
